import { Directive } from '@angular/core';

@Directive({
  selector: '[fcSuffix]',
  standalone: true,
  host: {
    class: 'fc-suffix',
  },
})
export class SuffixDirective {}
